import React from 'react';
import PropTypes from 'prop-types';

import get from 'lodash/get';
import { injectIntl, defineMessages } from 'react-intl';

import Link from '../../../components/BasicDataPod/Link';
import ListDataPod from '../../../components/ListDataPod';

const messages = defineMessages({
  title: {
    id: 'hubs.transfer.enrollment-terms.title',
    defaultMessage: 'Enrollment Terms',
  },
  tooltip: {
    id: 'hubs.transfer.enrollment-terms.tooltip',
    defaultMessage: `These are the semesters in which a transfer student can enroll and begin taking classes at this college.`,
  },
  tooltipHeader: {
    id: 'hubs.transfer.enrollment-terms.tooltip-header',
    defaultMessage: 'When You Can Enroll',
  },
  linkText: {
    id: 'hubs.transfer.enrollment-terms.link-text',
    defaultMessage: `View Application Deadlines`,
  },
});

const EnrollmentTerms = ({ intl, transferAdmissions }) => {
  let list = get(transferAdmissions, 'enrollmentTerms.value', '');
  const lastUpdated = get(transferAdmissions, 'lastUpdated.value');

  if (list.length) {
    list = list.split(',');
  }

  return list.length ? (
    <ListDataPod
      footer={lastUpdated}
      header={intl.formatMessage(messages.title)}
      tooltipHeader={intl.formatMessage(messages.tooltipHeader)}
      content={{
        list,
        info: (
          <Link
            linkText={intl.formatMessage(messages.linkText)}
            linkUrl="Transfer#application-deadlines"
          />
        ),
      }}
      tooltip={intl.formatMessage(messages.tooltip)}
    />
  ) : null;
};
EnrollmentTerms.propTypes = {
  intl: PropTypes.object,
  transferAdmissions: PropTypes.object,
};

export default injectIntl(EnrollmentTerms);
